import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styled from "styled-components";

const MarkdownContainer = styled.div`
	line-height: 1.6;

	h1,
	h2,
	h3,
	h4,
	p {
		margin-top: 0;
	}

	table {
		th {
			text-align: left;
		}
		td {
			padding-right: 1.5rem;
		}
	}
`;

const Markdown = (props: any) => {
	const processContent = (content: string) => {
		let processedContent = content;

		if (props.context && props.context.data) {
			for (var prop in props.context.data) {
				if (processedContent.indexOf(`{${prop}}`) > -1) {
					processedContent = processedContent.replaceAll(
						`{${prop}}`,
						props.context.data[prop]
					);
				}
			}
		}

		return processedContent;
	};

	return (
		<MarkdownContainer className="form-row-span">
			<ReactMarkdown
				components={{
					a: ({ node, ...props }) => {
						return <a {...props} target="_blank" rel="noopener noreferrer" />;
					},
				}}
				remarkPlugins={[remarkGfm]}
			>
				{processContent(props.content)}
			</ReactMarkdown>
		</MarkdownContainer>
	);
};
export default Markdown;
